(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ai-assistant-history', {
            parent: 'account',
            url: '/ai-assistant-history',
            data: {
                authorities: ['ROLE_AI_ASSISTANT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'global.menu.account.assistantHistory'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/ai-assistant-history/ai-assistant-history.html',
                    controller: 'AiAssistantHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aiAssistantHistory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
